import React from 'react';
import PropTypes from 'prop-types';
import S from 'calendar.scss';

const CalendarRow = ({ children, className }) => <div className={`${S.row} ${className || ''}`}>{children}</div>;

CalendarRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default CalendarRow;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarRow.jsx